import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=0f80364d&"
import script from "./FormPage.vue?vue&type=script&lang=js&"
export * from "./FormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/belgian-beer-factory/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f80364d')) {
      api.createRecord('0f80364d', component.options)
    } else {
      api.reload('0f80364d', component.options)
    }
    module.hot.accept("./FormPage.vue?vue&type=template&id=0f80364d&", function () {
      api.rerender('0f80364d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/FormPage.vue"
export default component.exports